import * as Sentry from "@sentry/react";
import { StartClient } from "@tanstack/react-start/client";
import { startTransition } from "react";
import { hydrateRoot } from "react-dom/client";
import { initDomNodeErrorGuard } from "./lib/dom-node-error-handler";
import { initPreloadErrorHandler } from "./lib/preload-error-handler";
import { initVersionCheck } from "./lib/version-check";

initPreloadErrorHandler();
initVersionCheck();
// Neutralize translation/extension-induced `insertBefore`/`removeChild` crashes
// before the first React commit. Must precede `hydrateRoot`.
initDomNodeErrorGuard();

// 프레임워크 기본 엔트리(react-start/src/default-entry/client.tsx)와 동일 구조.
// 델타: StrictMode 미사용(기존 main.tsx와 동일) + Sentry 에러 핸들러 장착.
// Sentry init 자체는 라우터 인스턴스가 필요해 getRouter()(src/router.tsx)에서 수행.
startTransition(() => {
	hydrateRoot(document, <StartClient />, {
		onUncaughtError: Sentry.reactErrorHandler(),
		onCaughtError: Sentry.reactErrorHandler(),
	});
});
